import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer";

import { baseStyles} from "../../styles";
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF";
import {VehicleInfoPDF} from "../../components/VehicleInfoPDF";
import {FinanceDealerPaymentInformationPDF} from "./FinanceDealerPaymentInformationPDF";
import {PurchaseDealerProfitInformationPDF} from "./PurchaseDealerProfitInformationPDF";
import {PurchaseDealerPriceBreakdownPDF} from "./PurchaseDealerPriceBreakdownPDF";
import {PurchaseDealerFinanceDetailsPDF} from "./PurchaseDealerFinanceDetailsPDF";
import {FinanceDealerRateInformationPDF} from "./FinanceDealerRateInformationPDF";
import {RebatesBreakdownPDF} from "../../components/RebatesBreakdownPDF";
import {HeaderPDF} from "../../components/HeaderPDF";
import {BasePDF} from "../../BasePDF";
import {FooterPDF} from '../../components/FooterPDF'

export const PurchaseDealerDisclosurePDF = ( { companyName, dealState, ...props } ) => {
    return (
        <BasePDF dealState={dealState} {...props}>
            <Document>
                <Page size="A4" style={baseStyles.page} wrap={false}>
                    <HeaderPDF pdfName={'Dealer Worksheet'} companyName={companyName}/>

                    <VehicleInfoPDF/>

                    <View style={{...baseStyles.tablesLayout}}>
                        <View style={{...baseStyles.flexColumn, ...baseStyles.leftColumn}}>
                            <FinanceDealerPaymentInformationPDF/>
                            <PurchaseDealerProfitInformationPDF/>
                            <FinanceDealerRateInformationPDF/>
                            <RebatesBreakdownPDF/>
                            <FeeBreakdownPDF/>
                        </View>

                        <View style={{...baseStyles.flexColumn, ...baseStyles.rightColumn}}>
                            <PurchaseDealerPriceBreakdownPDF/>
                            {/*<PurchaseDealerDownPaymentBreakdownPDF/>*/}
                            <PurchaseDealerFinanceDetailsPDF />
                            {/*<PurchaseDealerTaxInformationPDF/>*/}
                        </View>
                    </View>
                    <FooterPDF/>
                </Page>
            </Document>
        </BasePDF>
    )
}